import { render, staticRenderFns } from "./issue_card_inner.vue?vue&type=template&id=7bcb9963&"
import script from "./issue_card_inner.vue?vue&type=script&lang=js&"
export * from "./issue_card_inner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "issue_card_inner.vue"
export default component.exports